<script setup>
import Website_Traffic from '../library/metabox/Website_Traffic.vue';
import Recommendations from '../library/metabox/Recommendations.vue';
const { labels, data, urls, documentations, post_id, nonce, recommendations } = window.DATAAGENT_METABOX_POST;
const { plugin_url } = window.DATAAGENT_PLUGIN.path;
</script>

<template>
  <div class="dataagent-container">
    <div class="da:grid da:grid-cols-[1fr_auto] da:items-center da:gap-4 da:border da:border-gray-300 da:rounded-md da:p-2">
      <div class="da:flex da:items-center da:gap-2">
        <p class="da:text-sm da:text-gray-500">{{ labels.tips }}</p>
      </div>
      <div class="da:flex da:items-center">
        <a
          :href="urls.url_tips"
          target="_blank"
          class="da:bg-primary-600 da:text-white da:px-4 da:py-2 da:rounded-md da:flex da:items-center da:gap-2"
        >
          {{ labels.get_tips }}
          <i class="fas fa-external-link-alt"></i>
        </a>
      </div>
    </div>

    <Website_Traffic
      :labels="labels"
      :data="data"
      :urls="urls"
      :documentations="documentations"
      :post_id="post_id"
      :nonce="nonce"
    />
    <Recommendations :recommendations="recommendations" :labels="labels" />
  </div>
</template>
